import { useCallback } from 'react';
import { useInventoryId } from '@/hooks/use-inventory-id';
import { useNow } from '@/hooks/use-now';
import {
  useGetScenariosQuery,
  useDeleteScenarioMutation,
} from '@/api/scenarios';
import { Loading } from '@/components/loading';
import { Layout } from '@/components/layout';
import { ScenariosList } from '@/components/scenarios-list';

const Pathways = () => {
  const inventoryId = useInventoryId();
  const now = useNow();
  const { data: scenarios, isLoading: isLoadingScenarios } =
    useGetScenariosQuery(inventoryId);
  const [deleteScenario] = useDeleteScenarioMutation();
  const onDeleteScenario = useCallback(
    (scenarioId: number) => {
      deleteScenario({ inventoryId, scenarioId });
    },
    [inventoryId, deleteScenario],
  );

  if (isLoadingScenarios) {
    return <Loading />;
  }
  return (
    <Layout>
      <ScenariosList
        now={now}
        scenarios={scenarios ?? []}
        onDelete={onDeleteScenario}
      />
    </Layout>
  );
};

export { Pathways };
